
const team = [
    {
        id: 1,
        full_name: 'Aristide Nomo',
        function: 'topManager',
        image: 'assets/img/team/3.jpg',
        facebook: 'https://www.facebook.com/thewestheaven',
        instagram: 'https://www.facebook.com/thewestheaven',
        twitter: 'https://www.facebook.com/thewestheaven',
        youtube: 'https://www.facebook.com/thewestheaven',

    },
    {
        id: 2,
        full_name: 'Emma Newmanr',
        function: 'receptionist',
        image: 'assets/img/team/4.jpg',
        facebook: 'https://www.facebook.com/thewestheaven',
        instagram: 'https://www.facebook.com/thewestheaven',
        twitter: 'https://www.facebook.com/thewestheaven',
        youtube: 'https://www.facebook.com/thewestheaven',

    },
    {
        id: 3,
        full_name: 'Viktoria Freeman',
        function: 'headChef',
        image: 'assets/img/team/1.jpg',
        facebook: 'https://www.facebook.com/thewestheaven',
        instagram: 'https://www.facebook.com/thewestheaven',
        twitter: 'https://www.facebook.com/thewestheaven',
        youtube: 'https://www.facebook.com/thewestheaven',

    },
    {
        id: 4,
        full_name: 'Sofia Oldman',
        function: 'barman',
        image: 'assets/img/team/2.jpg',
        facebook: 'https://www.facebook.com/thewestheaven',
        instagram: 'https://www.facebook.com/thewestheaven',
        twitter: 'https://www.facebook.com/thewestheaven',
        youtube: 'https://www.facebook.com/thewestheaven',

    },
]
export default team